import React from 'react';
import { useLocation } from 'application/providers/RouterProvider';
import SkeletonItem from './SkeletonItem';

const MediaListItemSkeleton = () => {
  const { pathname } = useLocation();
  const WithExplicit = ['streams/saved/', 'points'].some((el) => pathname.includes(el));
  const withTime = pathname.includes('points');

  return (
    <SkeletonItem
      withPerformerTitle
      withExplicit={WithExplicit}
      withTime={withTime}
    />
  );
};

export default MediaListItemSkeleton;
